import { Link } from "react-router-dom";
import { profileData } from "@/mocks/profile";
import { newsList } from "@/mocks/news";

export default function HomeSidebar() {
  const hot = [...newsList].sort((a, b) => b.date.localeCompare(a.date)).slice(0, 5);

  return (
    <aside className="flex flex-col gap-5">
      <div className="bg-primary-50 border border-primary-100 rounded-lg p-5">
        <div className="flex flex-col items-center text-center">
          <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-background-50 bg-background-100 mb-3">
            <img
              src={profileData.avatar}
              alt={profileData.name}
              title="小泽玛利亚个人资料"
              className="w-full h-full object-top object-cover"
            />
          </div>
          <h3 className="font-heading text-lg font-semibold text-foreground-950">{profileData.name}</h3>
          <p className="text-xs text-foreground-500 mt-1">{profileData.tagline}</p>
          <Link
            to="/profile"
            className="mt-4 w-full inline-flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-user-line"></i>
            查看完整资料
          </Link>
        </div>
      </div>

      <div className="bg-background-50 border border-background-200 rounded-lg p-5">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading text-base font-semibold text-foreground-950 flex items-center gap-2">
            <i className="ri-fire-line text-accent-500"></i>
            热门推荐
          </h3>
          <Link to="/category/news" className="text-xs text-primary-700 hover:text-primary-800 cursor-pointer whitespace-nowrap">
            更多
          </Link>
        </div>
        <ul className="flex flex-col gap-4">
          {hot.map((item, idx) => (
            <li key={item.id}>
              <Link to={`/detail/${item.id}`} className="group flex items-start gap-3 cursor-pointer">
                <span className="w-6 h-6 rounded-md bg-background-100 text-foreground-500 text-xs flex items-center justify-center shrink-0 mt-0.5 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  {idx + 1}
                </span>
                <div className="min-w-0">
                  <p className="text-sm text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                    {item.title}
                  </p>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-background-50 border border-background-200 rounded-lg p-5">
        <h3 className="font-heading text-base font-semibold text-foreground-950 mb-4 flex items-center gap-2">
          <i className="ri-links-line text-primary-600"></i>
          快捷入口
        </h3>
        <div className="flex flex-wrap gap-2">
          {[
            { label: "最新新闻", to: "/category/news" },
            { label: "活动动态", to: "/category/activity" },
            { label: "生活花絮", to: "/category/life" },
            { label: "影视作品", to: "/works" },
            { label: "个人资料", to: "/profile" },
            { label: "关于我们", to: "/about" },
          ].map((link) => (
            <Link
              key={link.to + link.label}
              to={link.to}
              className="px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </aside>
  );
}